import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Container, FormField, Input, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiArrowDown } from '@mdi/js';
import Icon from '@mdi/react';
import CurrencyInput, { CurrencyInputHandle } from '../../../../../components/CurrencyInput';
import Favorites from '../../../../../components/extras/Favorites';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';



export const AdminMovementsTransfersPage = () => {
    //const storeAdmin = useStoreAdmin();

    const { menu } = useGlobalState();

    const refAmmount = useRef<HTMLInputElement>(null);
    const refTarget = useRef<HTMLDivElement>(null);

    const currencyInputRef = useRef<CurrencyInputHandle>(null);


    const [obs, setObs] = useState("");
    const [idUserSource, setIdUserSource] = useState(0);
    const [idUserTarget, setIdUserTarget] = useState(0);
    const [ammount, setAmmount] = useState(0);

    const handleTransfer = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/transfer',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    ammount: ammount,
                    idUserSource: idUserSource,
                    idUserTarget: idUserTarget,
                    obs: obs,
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
            const dataWeb = await response.json();

            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0) {
                setIdUserSource(0)
                setIdUserTarget(0)
                setAmmount(0)
                setObs("")
            }
            const data = await response.json();
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        };
    }
    useEffect(() => {

    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header actions={<Favorites />} variant="h1">Transferencia entre socios</Header>
                    <div style={{ width: 300 }}>
                        <Container footer={
                            <SpaceBetween direction='vertical' size='xs'>
                                <FormField label="Observaciones" constraintText={"Opcional"}>
                                    <Input value={obs} onChange={(e) => {
                                        setObs(e.detail.value.trim())
                                    }} />
                                </FormField>

                                <Box float='right'>
                                    <Button onClick={() => handleTransfer()} variant='primary' disabled={
                                        !(ammount > 0 && idUserSource > 0 && idUserTarget > 0 && idUserSource !== idUserTarget)
                                    }>Transferir</Button>
                                </Box>


                            </SpaceBetween>
                        }>
                            <SpaceBetween size='l' direction='vertical'>
                                <div style={{ width: 250, alignContent: "center" }}>
                                    <FormField label="Socio origen">
                                        <SelectUser
                                            autoFocus={true}
                                            value={idUserSource}

                                            onConfirm={(user) => {
                                                setIdUserSource(user?.idUser || 0)
                                                if (user) {
                                                    setTimeout(() => currencyInputRef.current?.focus(), 50)
                                                }
                                            }} />
                                    </FormField>
                                    <Box textAlign='center'>
                                        <Icon path={mdiArrowDown} size={2} />
                                    </Box>
                                    <Box textAlign='center'>
                                        <div style={{ width: 150, margin: "0 auto", textAlign: "left" }}>
                                            <FormField label="Monto">
                                                <CurrencyInput value={ammount}
                                                    onKeyUp={(k: string) => {
                                                        if (k === "Enter")
                                                            refTarget.current.focus()
                                                    }}
                                                    ref={currencyInputRef}
                                                    disabled={idUserSource === 0}
                                                    width={150} onChange={(value) => {
                                                        setAmmount(value)
                                                    }} />
                                            </FormField>
                                        </div>
                                    </Box>
                                    <Box textAlign='center'>
                                        <Icon path={mdiArrowDown} size={2} />
                                    </Box>
                                    <FormField label="Socio destino"
                                        errorText={idUserSource > 0 && idUserTarget > 0 && idUserSource === idUserTarget ? "Usuario de origen y destino no pueden ser el mismo" : ""}>
                                        <SelectUser
                                            ref={refTarget}
                                            disabled={idUserSource === 0 || ammount === 0}
                                            value={idUserTarget}
                                            onConfirm={(user) => setIdUserTarget(user?.idUser || 0)} />
                                    </FormField>
                                </div>
                            </SpaceBetween>
                        </Container>
                    </div>
                </SpaceBetween>
            }
        />
    );
};
